import { render, staticRenderFns } from "./couponCenter.vue?vue&type=template&id=5edba2ba&scoped=true&"
import script from "./couponCenter.vue?vue&type=script&lang=js&"
export * from "./couponCenter.vue?vue&type=script&lang=js&"
import style0 from "./couponCenter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./couponCenter.vue?vue&type=style&index=1&id=5edba2ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edba2ba",
  null
  
)

export default component.exports